import httpService from "../services/http-service";
import xmljs from "xml-js";
import Bus from "../services/bus.js";

export default {
  data() {
    return {
      EventProgress: 0
    };
  },
  methods: {
    handleError(response) {
      if (response.status != 0) {
        console.log(response.status);
      }

      // TO DO: algo pour générer un msg utilisateur sur l'erreur à faire
    },
    // traitement générique des appels http
    async httpHandler(promise) {
      return promise
        .then(response => {
          if (response.status !== 200) {
            return this.handleError(response);
          } else {
            return response.data;
          }
        })
        .catch(() => {
          return this.handleError({ status: 0 });
        });
    },
    // transformation des paramètre en objets côté client
    getParamStr(params) {
      var params_str = "";
      if (params) {
        params_str = `?params=${encodeURIComponent(JSON.stringify(params))}`;
      }
      return params_str;
    },
    // retourne une liste en fonction des paramètres demandés
    getObjectList(model, params) {
      var params_str = this.getParamStr(params);
      return this.httpHandler(httpService.client.get(`${model}/${params_str}`));
    },
    getObjectFile(model, params) {
      var params_str = this.getParamStr(params);
      var url_file = httpService.client.get(`${model}/${params_str}`);
      this.EventProgress = "1";
      httpService.client
        .get(`${model}/${params_str}`, {
          onDownloadProgress: function(progressEvent) {
            this.EventProgress =
              (progressEvent.loaded / progressEvent.total) * 100;
            Bus.$emit("event progress", this.EventProgress);
          }
        })
        .then(response => {
          url_file.then(response => {
            var link_to_download = window.document.createElement("a");
            window.open(response.config.url);
            link_to_download.href = window.URL.createObjectURL(
              response.config.url,
              { type: "application/zip" }
            );
            link_to_download.download = `${
              this.$store.getters.experienceIdentifier
            }_${Date.now()}.zip`;
            document.body.appendChild(link_to_download);
            link_to_download.click(); // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
            document.body.removeChild(link_to_download);
          });
        })
        .catch(error => {});
    },
    // retourne l'objet en fonction de l'identifiant sélectionné
    getObject(model, id) {
      return this.httpHandler(httpService.client.get(`${model}/${id}/`));
    },
    // retourne le détail (champ layout ) d'une expérience selon l'identifiant sélectionné
    getExperience(identifier) {
      return this.getObject("experience", identifier).then(experience => {
        experience.layout = xmljs.xml2js(experience.layout, {
          compact: false,
          spaces: 4
        });
        return experience;
      });
    },
    putObject(model, params){
      var params_str = this.getParamStr(params);
      return this.httpHandler(httpService.client.put(`${model}/${params_str}`));
    }
  }
};
